import { Box, Icon, Tag, Text } from '@nimbus-ds/components';
import { StarIcon } from '@nimbus-ds/icons';
import { DataList } from '@nimbus-ds/patterns';
import { TFunction } from 'i18next';
import { generatePath, Link } from 'react-router-dom';
import { ProductTransferListResponseDto } from '@tiendanube/common';
import { dateFormat, Format } from 'commons/utils/date';
import { CATALOG_ROUTES } from 'domains/Catalog/catalogRoutes';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import TransferListRowSkeleton from './TransferListRowSkeleton';
import { TransferStatus } from '../../../components';

const renderLocation = (location: string, isMain: boolean, t: TFunction) => (
  <Box display="flex" gap="2">
    <Text>{location}</Text>
    {isMain && (
      <Tag appearance="primary">
        <Icon source={<StarIcon />} />
        {t('main')}
      </Tag>
    )}
  </Box>
);

interface TransferListRowProps {
  transfer: ProductTransferListResponseDto[number];
}

function TransferListRow({
  transfer: {
    id,
    number,
    originLocation,
    originIsMain,
    destinationLocation,
    destinationIsMain,
    transferDate,
    status,
  },
}: Readonly<TransferListRowProps>) {
  const t = useTranslationCatalog('transfers.list');

  return (
    <DataList.Row backgroundColor="transparent">
      <Link
        className="nimbus--link nimbus--link--primary nimbus--link--base"
        to={generatePath(CATALOG_ROUTES.viewTransferDetails, { id })}
      >
        #{number}
      </Link>
      <Text>{renderLocation(originLocation, originIsMain, t)}</Text>
      <Text>{renderLocation(destinationLocation, destinationIsMain, t)}</Text>
      <Text>{dateFormat(transferDate, Format.DAY_MONTH)}</Text>
      <Text>
        <TransferStatus status={status} />
      </Text>
    </DataList.Row>
  );
}

TransferListRow.Skeleton = TransferListRowSkeleton;

export default TransferListRow;
